export const aboutFaqs = [
  {
    question: 'Can you fix an existing app or codebase?',
    answer:
      'Absolutely. That’s what our team is built for. We diagnose bugs, performance issues, technical debt, security concerns, and other problems in existing web and mobile applications. We identify the root cause and recommend the right fix—without pushing an unnecessary rebuild.',
  },
  {
    question: 'Can you help with AI-generated or poorly built code?',
    answer:
      'Yes. AI can accelerate development, but AI-generated code still needs experienced engineers to review, test, secure, and optimize it. We can audit your codebase, identify issues, and bring it to a reliable, production-ready state.',
  },
  {
    question: 'What can’t AI do?',
    answer:
      'AI is powerful, but it isn’t a replacement for experienced engineers. It can generate code quickly, but it doesn’t always understand your business context, make the right architectural decisions, catch subtle bugs, or know when generated code is unsafe or unsuitable for production. That’s where human expertise matters.',
  },
  {
    question: 'Do you also build new apps from scratch?',
    answer:
      'Yes. We provide end-to-end design and development for new web and mobile applications. Whether you need to fix an existing product or build something completely new, we tailor our approach to your goals and technical needs.',
  },
  {
    question:
      'Why should I choose to hire an agency if I can just hire an individual freelancer at a potentially lower price?',
    answer:
      "Great question, think of this - would you buy a name brand from an authentic store or directly from its supplier? The three biggest benefits of working with an agency are: quality control, fulfilling timeline, efficiency. We are experts in the field and we know right away when we see cheap code. Additionally, we manage our team with agile methodology, allowing us to be on track and meet deadlines, and we are always flexible with adjusting the number of assigned developers to your project. Last but not least, we closely monitor efficiency, we know what's a reasonable estimate on a certain task and help you keep track of both time and budget.",
  },
  {
    question: 'Where are your developers based?',
    answer:
      'Our team spans the U.S. and international locations, giving you access to great talent across time zones. That means your project can keep moving while you sleep.',
  },
  {
    question: 'Can I work directly with your developers?',
    answer:
      'Definitely, all of our developers can communicate in English fluently, and we love it when our clients interact with our team at a more personal level.',
  },
  {
    question: 'I have an idea, how do I start?',
    answer:
      "Fantastic, you land at the right place! We have years of experiences in building projects from scratch - from consultation to design, development, then delivery. Feel free to contact us, we are here to turn your idea into reality, and we've successfully done this plenty of times.",
  },
  {
    question: "What's the usual turnaround on projects?",
    answer:
      "Turnaround can vary a lot depending on project size and urgency. We will be able to assign the number of developers involved in your project accordingly, and trust us, we're good at it!",
  },
  {
    question: 'I have a team now but am looking for other options / evaluating my current team, what do you suggest?',
    answer:
      "First of all, make sure that you have access to and own everything, most importantly, the codebase. However, if you have missing pieces, rest assured we'll help you put those pieces together. We can help evaluate quality of current codebase, put together what you need during the transition, and draw out plan to prevent all foreseeable issues. We're here to solve problems for you.",
  },
];
